const { disableBodyScroll, enableBodyScroll } = require("body-scroll-lock");

export default class Search {
  constructor() {
    this.search = $(".navbar-search")[0];

    if (this.search) {
      // this._init();
    }
  }

  _init() {
    this.backdrop = $(".navbar-search-backdrop")[0];
    this.form = $(this.search).find("form")[0];
    this.toggle = $(this.search).find(".navbar-search__toggle")[0];
    this.searchfield = $(this.search).find(".navbar-search__input")[0];
    this.isSearchVisible = true;

    this.toggle.addEventListener("click", this._handelToggleClick.bind(this));

    this.backdrop.addEventListener(
      "click",
      this._handelBackdropClick.bind(this)
    );

    $(window).on(
      "luther:overlay-instead-of-desktop",
      this._handleWindowResize.bind(this)
    );
  }

  _handleWindowResize(event, hideSearch) {
    if (hideSearch) {
      this._closeSearch();
      if (this.isSearchVisible) {
        document.body.classList.add("navbar-search-is-hidden");
        this.isSearchVisible = false;
      }
    } else {
      if (!this.isSearchVisible) {
        document.body.classList.remove("navbar-search-is-hidden");
        this.isSearchVisible = true;
      }
    }
  }

  _handelToggleClick(evt) {
    evt.preventDefault();
    var isSearchOpen = this.isSearchOpen || false;
    if (!isSearchOpen) {
      this._openSearch();
    } else {
      this._closeSearch();
    }
  }

  _openSearch() {
    this.isSearchOpen = true;
    document.body.classList.add("search-is-open");
    this.searchfield.focus();
  }

  _closeSearch() {
    this.isSearchOpen = false;
    this.searchfield.blur();
    document.body.classList.remove("search-is-open");
  }

  _handelBackdropClick(evt) {
    if (this.isSearchOpen) {
      this._closeSearch();
    }
  }
}
